import { Filter } from '@anytag/shared-molecules';
import { FilterAction } from '@anytag/shared-types';
import { Template } from './Template';
import { InfluencerProfileCampaignsFilterFormValues } from './schemaTypes';

export type CampaignListFilterProps = FilterAction<InfluencerProfileCampaignsFilterFormValues>;

export const InfluencerProfileCampaignsFilter = ({ filter, setFilter }: CampaignListFilterProps) => (
  <Filter.Provider onSubmit={setFilter} values={filter}>
    <Template />
  </Filter.Provider>
);

export * from './schemaTypes';
